import { useCallback, useEffect, useState } from 'react';
import { restApi } from '../../../../services/api';
import { OrderTransportCondition } from '../../order.types';

export type OrderDefinitions = {
  shippingCompanyIntegration: boolean;
  orderTransportCondition: OrderTransportCondition;
  orderClassificationsIntegration: boolean;
  hasOrderOperationsIntegration: boolean;
  hasOrderChargeTypeIntegration: boolean;
  hasActiveTmsIntegration: boolean;
  showLocals: boolean;
  showEmitInvoice: boolean;
  batchItemsIntegration: boolean;
};

const orderDefinitionsDefault: OrderDefinitions = {
  shippingCompanyIntegration: false,
  orderTransportCondition: OrderTransportCondition.NONE,
  orderClassificationsIntegration: false,
  showLocals: false,
  showEmitInvoice: false,
  batchItemsIntegration: false,
  hasOrderOperationsIntegration: false,
  hasOrderChargeTypeIntegration: false,
  hasActiveTmsIntegration: false,
};

export interface UseOrderDefinitionsResult {
  orderDefinitions: OrderDefinitions;
  isLoadingOrderDefinitions: boolean;
  hasLoadedOrderDefinitions: boolean;
}

const useOrderDefinitions = (): UseOrderDefinitionsResult => {
  const [orderDefinitions, setOrderDefinitions] =
    useState<OrderDefinitions>(orderDefinitionsDefault);
  const [isLoadingOrderDefinitions, setIsLoadingOrderDefinitions] = useState(true);
  const [hasLoadedOrderDefinitions, setHasLoadedOrderDefinitions] = useState(false);

  const fetchOrderDefinitions = useCallback(async () => {
    setIsLoadingOrderDefinitions(true);

    try {
      const response = await restApi.get<OrderDefinitions>('orders/definitions');
      if (response.ok && response.data) {
        setOrderDefinitions(response.data);
        setHasLoadedOrderDefinitions(true);
      }
    } finally {
      setIsLoadingOrderDefinitions(false);
    }
  }, [setOrderDefinitions]);

  useEffect(() => {
    fetchOrderDefinitions();
  }, [fetchOrderDefinitions]);

  return { orderDefinitions, isLoadingOrderDefinitions, hasLoadedOrderDefinitions };
};

export default useOrderDefinitions;
